import React from "react";
import Dashboard from "./Pages/Dashborad";
import LoginPage from "./Pages/Login";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Profile from "./Pages/Profile";
import Groups from "./Pages/Groups";
import EditUser from "./Pages/EditUser";
import AcessPermission from "./Pages/AccessPermission";
import State from "./Pages/State";
import District from "./Pages/District";
import Cities from "./Pages/City";
import Location from "./Pages/Location";
import { PasswordModalProvider } from "./contexts/PasswordModalContext";
import { UserTaskProvider } from "./contexts/UserTaskContext";
import { NotificationProvider } from "./contexts/NotificationContext"; // Add this import
import ChangePasswordModal from "./Components/ChangePasswordModal";
import CreateProject from "./Pages/CreateProject";
import EditProject from "./Pages/EditProject";
import MediaSource from "./Pages/MediaSource";
import PropertyType from "./Pages/PropertyType";
import SubMediaSource from "./Pages/SubMediaSource";
import LeadGroup from "./Pages/LeadGroup";
import CreateLeadForm from "./Pages/CreateLead";
import LeadList from "./Pages/ViewLead";
import LeadReport from "./Pages/LeadReport";
import CampaignTable from "./Pages/CampaignView";
import EditCampaign from "./Pages/EditCampaign";
import EditLead from "./Pages/EditLead";
import CreateUserTask from "./Pages/CreateUserTask";
import UserTask from "./Pages/UserTaskView";
import LeadListsTask from "./Pages/LeadListsTask";
import EditUserTask from "./Pages/EditUserTask";
import CreateUserDemo from "./Pages/CreateUser";
import UserTableDemo from "./Pages/UserView";
import ShowCardLeadList from "./Components/ShowCardLeadList";
import ActionRequiredLead from "./Components/ActionRequiredLead";
import ReconnectLeads from "./Components/ReconnectLeads";
import UserTaskTable from "./Pages/UserTaskViewDemo";
import ProjectViewDemo from "./Pages/ProjectViewDemo";
import EmailFormatView from "./Pages/EmailFormatView";
import UpdatedUserTaskComponent from "./Components/UpdatedUserTaskComponent";
import ApiChannelTable from "./Pages/ApiChannelTable";
import CampaignTypeTable from "./Pages/CampaignTypeTable";
import RoutingPriority from "./Pages/RoutingPriority";
import ImportLead from "./Pages/ImportLead";
import LeadDashboard from "./Pages/LeadDashboard";
import UserActiveTask from "./Pages/UserActiveTask";
import UserScore from "./Pages/UserScore";
import SuperAdminDashboard from "./Pages/SuperAdminDashboard";
import PlanTable from "./Pages/PlanTable";
import TenantView from "./Pages/TenantView";

import StageAnalysisReport from "./Pages/StageAnalysisReport";
import StageAnalysisReportLeadDetails from "./Components/StageAnalysisReportLeadDetails";
import LeadLostReport from "./Components/LeadLostReport";
import LeadLostDetails from "./Components/LeadLostDetails";
import SiteVisitedReport from "./Components/SiteVisitedReport";
import SiteVisitedDetails from "./Components/SiteVisitedReportDetails";
import UserActivityReport from "./Components/UserActivityReport";
import { BASE_URL } from "./Services/APIService";
import LeadDetails from "./Pages/user-activity-details";
import NextFollowupReport from "./Components/NextFollowupReport";
import PreSalesSitevisit from "./Components/PreSalesSitevisit";
import CompleteTaskReports from "./Components/CompleteTaskReport";
import Social from "./Pages/Social";
import { ManagerModalProvider } from "./contexts/ManagerModalContext";
import ManagerModal from "./Components/ManagerModal";
import { UserModalProvider } from "./contexts/UserModalContext";
import UserModal from "./Components/UserModal";
import Reasons from "./Pages/Reason";
const tenantId = parseInt(localStorage.getItem("tenantId") || "0", 10);

// Protected route component with proper TypeScript typing
const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const authToken = localStorage.getItem("authToken");

  if (!authToken) {
    // Redirect to login if no authToken is found
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  // Your API base URL - adjust according to your backend  http://localhost:8088  https://rprocrmsasdevapi.rprocrm.com
  const BASEURL = BASE_URL;
  const API_BASE_URL = BASEURL.replace(/\/api\/?$/, "");

  // Get userID from localStorage or your auth system
  const getUserId = (): number => {
    const userInfo = localStorage.getItem("UserId");
    if (userInfo) {
      try {
        const userID = parseInt(userInfo);
        return userID || 0;
      } catch (error) {
        console.error("Error parsing user info:", error);
        return 0;
      }
    }
    return 0;
  };

  const userID = getUserId();

  return (
    <PasswordModalProvider>
      <ManagerModalProvider>
        <UserModalProvider> 
      <UserTaskProvider>
        <NotificationProvider baseUrl={API_BASE_URL}>
          {" "}
          {/* Add NotificationProvider */}
          <Router>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              {/* All your existing routes remain the same */}
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/groups"
                element={
                  <ProtectedRoute>
                    <Groups />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/editUser"
                element={
                  <ProtectedRoute>
                    <EditUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/acessPermission"
                element={
                  <ProtectedRoute>
                    <AcessPermission />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/state"
                element={
                  <ProtectedRoute>
                    <State />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/district"
                element={
                  <ProtectedRoute>
                    <District />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/city"
                element={
                  <ProtectedRoute>
                    <Cities />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/location"
                element={
                  <ProtectedRoute>
                    <Location />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/createProject"
                element={
                  <ProtectedRoute>
                    <CreateProject />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/editProject"
                element={
                  <ProtectedRoute>
                    <EditProject />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mediaSource"
                element={
                  <ProtectedRoute>
                    <MediaSource />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/propertyType"
                element={
                  <ProtectedRoute>
                    <PropertyType />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/subMediaSource"
                element={
                  <ProtectedRoute>
                    <SubMediaSource />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/LeadGroup"
                element={
                  <ProtectedRoute>
                    <LeadGroup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/createLead"
                element={
                  <ProtectedRoute>
                    <CreateLeadForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leadView"
                element={
                  <ProtectedRoute>
                    <LeadList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leadReport"
                element={
                  <ProtectedRoute>
                    <LeadReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/campaignView"
                element={
                  <ProtectedRoute>
                    <CampaignTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/editCampaign"
                element={
                  <ProtectedRoute>
                    <EditCampaign />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/editLead"
                element={
                  <ProtectedRoute>
                    <EditLead />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leadDetails"
                element={
                  <ProtectedRoute>
                    <LeadDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/createUserTask"
                element={
                  <ProtectedRoute>
                    <CreateUserTask />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/userTaskViewDemo"
                element={
                  <ProtectedRoute>
                    <UserTask />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/leadliststask"
                element={
                  <ProtectedRoute>
                    <LeadListsTask />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/editUserTask"
                element={
                  <ProtectedRoute>
                    <EditUserTask />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/userView"
                element={
                  <ProtectedRoute>
                    <UserTableDemo />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ShowCardLeadList"
                element={
                  <ProtectedRoute>
                    <ShowCardLeadList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/UserTaskView"
                element={
                  <ProtectedRoute>
                    <UserTaskTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projectView"
                element={
                  <ProtectedRoute>
                    <ProjectViewDemo />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/EmailFormat"
                element={
                  <ProtectedRoute>
                    <EmailFormatView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ApiChannel"
                element={
                  <ProtectedRoute>
                    <ApiChannelTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/CampaignType"
                element={
                  <ProtectedRoute>
                    <CampaignTypeTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/RoutingPriority"
                element={
                  <ProtectedRoute>
                    <RoutingPriority />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ImportLead"
                element={
                  <ProtectedRoute>
                    <ImportLead />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/Social"
                element={
                  <ProtectedRoute>
                    <Social />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/LeadDashboard"
                element={
                  <ProtectedRoute>
                    <LeadDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/UserActiveTask"
                element={
                  <ProtectedRoute>
                    <UserActiveTask />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/UserScore"
                element={
                  <ProtectedRoute>
                    <UserScore />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/SuperAdminDashboard"
                element={
                  <ProtectedRoute>
                    <SuperAdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/PlanTable"
                element={
                  <ProtectedRoute>
                    <PlanTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/TenantView"
                element={
                  <ProtectedRoute>
                    <TenantView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/stageAnalysisReport"
                element={
                  <ProtectedRoute>
                    <StageAnalysisReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-details"
                element={
                  <ProtectedRoute>
                    <StageAnalysisReportLeadDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leadLostReport"
                element={
                  <ProtectedRoute>
                    <LeadLostReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lead-lost-details"
                element={
                  <ProtectedRoute>
                    <LeadLostDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/SiteVisitedReport"
                element={
                  <ProtectedRoute>
                    <SiteVisitedReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/site-visited-details"
                element={
                  <ProtectedRoute>
                    <SiteVisitedDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/userActivityReport"
                element={
                  <ProtectedRoute>
                    <UserActivityReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/NextFollowupReport"
                element={
                  <ProtectedRoute>
                    <NextFollowupReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/PreSalesSitevisit"
                element={
                  <ProtectedRoute>
                    <PreSalesSitevisit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/CompleteTaskReport"
                element={
                  <ProtectedRoute>
                    <CompleteTaskReports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ActionRequiredLead"
                element={
                  <ProtectedRoute>
                    <ActionRequiredLead />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/ReconnectLeads"
                element={
                  <ProtectedRoute>
                    <ReconnectLeads />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/ReasonMaster"
                element={
                  <ProtectedRoute>
                    <Reasons />
                  </ProtectedRoute>
                }
              />
              <Route path="/user-activity-details" element={<LeadDetails />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            {/* Modal is available globally but only shows when triggered */}
            <ChangePasswordModal userID={userID} />
            <ManagerModal />
            <UserModal />
          </Router>
        </NotificationProvider>{" "}
        {/* Close NotificationProvider */}
      </UserTaskProvider>
      </UserModalProvider> 
      </ManagerModalProvider>
    </PasswordModalProvider>
  );
}

export default App;
